import { render } from "./App.vue?vue&type=template&id=52531eca"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=52531eca&lang=scss"
script.render = render

export default script